import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import FacturaGenerator from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AdminLogin from './login';
import AdminPanel from './AdminPanel';
 
const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<AdminLogin />} />
      {/* <Route path='/main' element={<FacturaGenerator />}></Route> */}
      <Route path='/admin' element={<AdminPanel />}></Route>
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();